import React, { Fragment, FunctionComponent, useEffect } from "react";

export type EnumLoaderComponentProps = {
    /** Příznak, zda je již enum načten  */
    enumLoaded: boolean;

    /** Funkce, jejíž volání zajistí načtení enumu */
    loadEnum: () => void;
};

export const EnumLoaderComponent: FunctionComponent<EnumLoaderComponentProps> = ({
    enumLoaded,
    loadEnum,
    children,
}) => {
    useEffect(() => {
        if (!enumLoaded) {
            loadEnum();
        }
    }, [loadEnum, enumLoaded]);

    return (
        <Fragment>
            {children}
        </Fragment>
    );
};
